<template>
  <g>
    <polygon
      class="topPolygon"
      :class="{plywood}"
      :points="topPolygon"
    />
    <polygon
      class="rightPolygon"
      :points="rightPolygon"
    />
    <rect
      class="frontRect"
      :x="x"
      :y="y"
      :width="width"
      :height="height"
    />
    <line
      v-for="(line, i) in topLines"
      :key="i"
      class="topLine"
      :x1="line.x1"
      :y1="line.y1"
      :x2="line.x2"
      :y2="line.y2"
    />
  </g>
</template>

<script>
	export default {
		name: 'Shelf',
		props: {
			x: Number,
			y: Number,
			width: Number,
			height: {
				type: Number,
				default: 10,
			},
			parts: {
				type: Number,
				default: 6,
			},
			depthOffset: Object,
      plywood: {
        type: Boolean,
        default: true,
      },
		},
		computed: {
			topPolygon() {
				return `${this.x},${this.y}
						${this.x + this.width},${this.y}
						${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y}
						${this.x + this.depthOffset.x},${this.y - this.depthOffset.y}`;
			},
			rightPolygon() {
				return `${this.x + this.width},${this.y}
						${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y}
						${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y + this.height}
						${this.x + this.width},${this.y + this.height}`;
			},
			topLines() {
				const lines = [];
				const partWidth = this.width / (this.parts - 1);

				for (let i = 1; i < this.parts - 1; i++) {
					lines.push({
						x1: this.x + partWidth * i,
						y1: this.y,
						x2: this.x + this.depthOffset.x + partWidth * i,
						y2: this.y - this.depthOffset.y,
					});
				}

				return lines;
			},
		},
	};
</script>

<style scoped>
	.topPolygon {
		fill: #eaeaea;
	}
	.topPolygon.plywood {
    fill: #d1ba9e;
  }
	.rightPolygon {
		fill: #c4c6c8;
	}
	.frontRect {
		fill:#dcddde;
	}
	.topLine {
		stroke: #BABCBE;
		stroke-width: 0.4;
	}
</style>
